<template>
	<div class="product-list" :style="{backgroundColor:editablePageConfig.editable_page_config_content.back_color,paddingTop:editablePageConfig.editable_page_config_content.margin_top,paddingBottom:editablePageConfig.editable_page_config_content.margin_bottom}">
		<div class="product-list-header">
      <div class="header-title">{{ editablePageConfig.editable_page_config_content.text[0]['list'][0]['content'] }}</div>
    </div>
    <div class="product-list-body">
			<div
					v-for="(item, index) in editablePageConfig.goods_list[0]"
					v-bind:key="index"
					class="product-info"
					v-bind:class="{ border: index % 2 == 0 }"
					@click="productClick(item.goods_id)"
			>
				<img class="product-icon" v-lazy="item.goods_image_url"/>
				<span class="product-title">{{ item.goods_name }}</span>
				<div class="product-bottom">
					<span class="product-price">${{ item.goods_price }}</span>
					<span class="product-buy">sales {{ item.goods_salenum }}</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
  name: 'Model19',
  data () {
    return {}
  },
  props: ['editablePageConfig'],
  components: {

  },
  computed: {

  },
  methods: {
	  productClick (goods_id) {
		  this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: goods_id } })
	  }
  }
}
</script>
<style lang="scss" scoped>
.product-list {
	background: #ffffff;
	.product-list-header {
		background: #1c1719;
    display:-webkit-box;
		height:2.65rem;
		padding: 0 0.25rem;
		border-bottom: 1px solid #f5f5f5;
    -webkit-box-align:center;
    -webkit-box-pack:center;
		.header-title {
			font-size: 0.8rem;
			color: #fff;
			font-weight:700;
		}
		.header-icon {
			width:1rem;
			height:1rem;
		}
	}
	.product-list-body {
		background: #fff;
		display: flex;
		flex-wrap: wrap;
	}
}
.border {
	border-right: 1px solid #f5f5f5;
}
.product-info {
	display: flex;
	flex-direction: column;
	overflow: hidden;
	padding:0.5rem;
	justify-content: flex-end;
	border-bottom: 1px solid #f5f5f5;
	width:50%;box-sizing:border-box;
	.product-icon {
		align-self: center;
		width:100%;box-sizing:border-box;
	}
	.product-title {
		font-size: .6rem;
		margin-top: 0.3rem;
		overflow: hidden;
		display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    color: #666;
    text-overflow: ellipsis;
	}
	.product-bottom {
		display: flex;
		justify-content: space-between;
		margin-top:.4rem;
		line-height:1rem;
		.product-price {
			color: $primaryColor;
			font-size:.7rem;
		}
		.product-buy {
			color: #999999;
			font-size:.65rem;
		}
	}
}
</style>
